export default __webpack_public_path__ + "static/histogram-with-specified-bins-69f5186462255e5f2be07c8668d44a5c.png";